export const L10N = {
  LABEL_BOOKING_DETAILS: { id: 'core.label.booking_details' },
  LABEL_BOOKING_EXTRAS: { id: 'core.label.booking_extras' },
  LABEL_EXTRAS: { id: 'common.label.extras' },
  LABEL_OBSERVATIONS: { id: 'common.label.observations' },
  LABEL_ROOM_NUMBER: { id: 'common.label.room_number' },
  LABEL_SUBJECT_TO_AVAILABILITY: { id: 'core.label.subject_to_availability' },
};
